<template>
  <v-app>
    <v-container fill-height fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="12" md="4" lg="4">
          <v-card elevation="0">
            <br/>
            <!-- <v-img src="https://www.thecamtool.com/dist/image_logo.png" alt="Fedorae Education Log" contain
              height="50"  class="ma-2"></v-img> -->

            <div class="text-center">
              <h1 class="mb-4">Cam-Tool</h1>
            </div>
            <v-card-text>
              <v-form ref="form" v-model="hidden" lazy-validation>
                <v-text-field  v-model="email" :rules="emailRules" @blur="resetValidation" outlined label="Email"
                  placeholder="example@example.com" :hide-details="hidden" class="mb-3"></v-text-field>
                <v-text-field v-model="password" :rules="passwordRules" @blur="resetValidation" outlined
                  :type="isPasswordVisible ? 'text' : 'password'" label="Password" placeholder="············"
                  :hide-details="hidden"></v-text-field>

                <v-btn block  :disabled="isLoading" large class=" mt-2 red darken-1 white--text font-weight-black" @click="loginUser()" :loading="isLoading">
                  {{ text_login }}
                </v-btn>

               <!--  <v-btn block large class="mt-2 mb-5 blue darken-1 white--text font-weight-black"  @click="loginWithGoogle()">
                  Sign in with Google
                </v-btn>  -->
              </v-form>

              <v-alert dense  type="error" v-model="checked_error" class="mt-3 text-caption text-center">
                {{ errors }}
              </v-alert>

            </v-card-text>

          </v-card>
        </v-col>
      </v-row>
      
    </v-container>
  </v-app>
</template>

<script>

import axios from 'axios'
export default {

  name: 'app-login',

  data: () => ({

    text_user: '',
    text_pass: '',
    isLoading: false,
    errors: [],

    emailRules: [
      v => !!v || 'Enter your email',



    ],
    passwordRules: [

      v => !!v || 'Enter your password',

    ],
    checked_error: false,
    alert_title: '',
    valid: false,
    text_login: 'Login',
    hidden: false,
    overlay: false,
    email: '',
    password: '',
    isPasswordVisible: false,
    IsLogin: false
  }),
  mounted() {

  


  },
  watch: {
    overlay(val) {
      val && setTimeout(() => {
        this.overlay = false
      }, 3000)
    },
  },
  created() {
    var hasLogin = localStorage.getItem('hasLogin')


    if (hasLogin) {

      this.$router.push('dashboard')
    }

  },
  methods: {

 

    validate() {

      this.$refs.form.validate()

    },
    async loginWithGoogle() {

      const googleuser = await this.$gAuth.signIn();

      this.IsLogin = this.$gAuth.isAuthorized;

      if (this.IsLogin) {
        this.$router.push('fb-videope')

      }

      console.log("User", googleuser);

    },

    resetValidation() {

      this.$refs.form.resetValidation()


    },

    loginUser() {
      const isValid = this.$refs.form.validate();

      if (!isValid) {
        this.validate()
        console.log(isValid)

      } else {
     
           this.isLoading = true
           this.alert_title = ''
              
          
      
        var bodyFormData = new FormData();
        bodyFormData.append('email', this.email);
        bodyFormData.append('password', this.password);
        axios.post('https://v2.thecamtool.com/user/login', bodyFormData).then((data) => {

          // var hasErorrsProperty = Object.prototype.hasOwnProperty.call(data.data, "errors");
          var hasErorrsProperty = data.data.data.expired
        
          if (hasErorrsProperty) {
          
            this.errors = data.data.data.message;
            this.checked_error = true;
            this.text_login = 'Login'
            this.isLoading = false


          } else {
       
            this.checked_error = false
            this.$store.commit("setAuthentication", true);
            // this.$router.push({ name: "fb-videope" });
            this.$router.push({ name: "dashboard" });
            window.localStorage.setItem('info', JSON.stringify(data.data))
            window.localStorage.setItem('hasLogin', true)


          }



        }).catch((error) => {


          this.checked_error = true;
          this.text_login = 'Login'
          this.errors = "Somthing Wrong !";  
          this.isLoading = false

        }).finally((data)=>{
          this.isLoading = false
          this.text_login = 'Login'
        })

      }

    }
  }
}
</script>
<style lang="css" scoped>
  .v-card{
     border-radius: 10px;
  }
</style>

<style>
.g-signin-button {
  /* This is where you control how the button looks. Be creative! */
  display: inline-block;
  padding: 4px 8px;
  border-radius: 3px;
  background-color: #3c82f7;
  color: #fff;
  box-shadow: 0 3px 0 #0f69ff;
}
</style>